/**
 * Vote content creation helpers
 */
import type { VoteContent, DAGObject } from '../dag/types.js';
import type { Identity } from '../identity/identity.js';

/**
 * Create an upvote
 */
export function createUpvote(
  identity: Identity,
  targetHash: string
): DAGObject<VoteContent> {
  const content: VoteContent = {
    target: targetHash,
    value: 1,
  };

  return identity.createObject('vote', content, [targetHash]);
}

/**
 * Create a downvote
 */
export function createDownvote(
  identity: Identity,
  targetHash: string
): DAGObject<VoteContent> {
  const content: VoteContent = {
    target: targetHash,
    value: -1,
  };

  return identity.createObject('vote', content, [targetHash]);
}

/**
 * Check if object is a vote
 */
export function isVote(obj: DAGObject): obj is DAGObject<VoteContent> {
  return obj.type === 'vote';
}
